import { Action } from '@/_core/fluxstore/types';
import { queryExecutor } from '@/_core/cqrs';
import { snackbar } from '@/_core/app-components/use';
import { mapArrayDtoPropsToCamelCase } from '@/_core/utils/mapDtos';
import { StorymapState, TrashRow } from '../../types';
import { useStorymapStore } from '../../useModule';
import { TrashedCardsQuery } from '../../../api/queries';

const { registerMiddleware, registerReducer } = useStorymapStore();

export class InitTrashedCards extends Action<StorymapState> {
    public static ACTION_TYPE = 'InitTrashedCards';

    public constructor() {
        super(InitTrashedCards.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState): Promise<boolean> => {
    const token = state.trashState.trashLoadToken + 1;
    state.trashState.trashLoadToken = token;
    state.trashState.isDialogOpen = true;
    state.trashState.isLoading = true;
    state.trashState.loadError = '';

    try {
        const res = await queryExecutor.executeQuery(new TrashedCardsQuery(state.id));
        if (state.trashState.trashLoadToken === token && state.trashState.isDialogOpen) {
            state.trashState.rows = mapArrayDtoPropsToCamelCase(res.Rows) as TrashRow[];
            state.trashState.selectedRowId = state.trashState.rows.some((x) => x.id === state.trashState.selectedRowId)
                ? state.trashState.selectedRowId
                : null;
            state.trashState.loadError = '';
        }
    } catch (error) {
        if (state.trashState.trashLoadToken === token && state.trashState.isDialogOpen) {
            state.trashState.loadError = (error as Error).message;
            snackbar.showError('Trash could not be loaded. Please try again.');
        }
    } finally {
        if (state.trashState.trashLoadToken === token && state.trashState.isDialogOpen) {
            state.trashState.isLoading = false;
        }
    }

    return true;
};

const reducer = (): void => {
    // State is updated in middleware to preserve previous rows on failed loads.
};

//@ts-ignore
registerMiddleware(InitTrashedCards.ACTION_TYPE, middleware);
//@ts-ignore
registerReducer(InitTrashedCards.ACTION_TYPE, reducer);
